import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../../shadcn/ui/card";
import { Button } from "../../shadcn/ui/button";
import { Mail, CheckCircle } from "lucide-react";

const Confirm = () => {
  return (
    <div className="w-full max-w-md mx-auto px-4">
      <Card className="border-0 shadow-2xl">
        <CardHeader className="space-y-1">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
              <Mail className="w-10 h-10 text-blue-600" />
            </div>
          </div>
          <CardTitle className="text-2xl font-semibold text-center">Thank You!</CardTitle>
          <CardDescription className="text-center">Your account has been created successfully</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-2">
            <div className="flex items-start space-x-3">
              <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-blue-900">
                Please check your email to complete your signup and activate your account.
              </p>
            </div>
          </div>
          <p className="text-xs text-gray-500 text-center">If you don't see the email, check your spam folder.</p>
        </CardContent>
        <CardFooter className="flex flex-col space-y-4">
          <Button asChild className="w-full">
            <Link to="/signin">Go to Sign In</Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default Confirm;
